import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'astroturf/react';

export class NameForm extends Component {
  static propTypes = {
    saveName: PropTypes.func.isRequired,
    cta: PropTypes.string.isRequired,
    ctaIconClassName: PropTypes.string.isRequired,
  };

  constructor(props) {
    super(props);
    this.state = { value: '' };

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleChange(e) {
    this.setState({ value: e.target.value });
  }

  handleSubmit(e) {
    if (this.state.value) {
      this.props.saveName({ name: this.state.value });
    }
    e.preventDefault();
  }

  render() {
    return (
      <form>
        <label style={{ width: '100%' }}>
          List Name:
          <div>
            <input
              type="text"
              ref={(ref) => {
                if (ref) {
                  // setTimeout is used to work around focus() not functioning immediately
                  setTimeout(() => {
                    ref.focus();
                  }, 5);
                }
              }}
              value={this.state.value}
              onChange={this.handleChange}
              style={{
                backgroundColor: '#EEEEF0',
                width: '100%',
                borderStyle: 'none',
                padding: '6px',
                borderRadius: '6px',
              }}
            />
          </div>
        </label>
        {this.props.errors ? (
          <div style={{ color: 'red' }}>
            {`That name ${this.props.errors}.`}
          </div>
        ) : null}
        {this.state.value ? (
          <MainCtaButton onClick={this.handleSubmit}>
            <i
              className={this.props.ctaIconClassName}
              style={{ marginRight: '6px' }}
            ></i>
            {this.props.cta}
          </MainCtaButton>
        ) : (
          <InactiveCtaButton onClick={this.handleSubmit}>
            <i
              className={this.props.ctaIconClassName}
              style={{ marginRight: '6px' }}
            ></i>
            {this.props.cta}
          </InactiveCtaButton>
        )}
      </form>
    );
  }
}

export default class CreateWorkCollectionModal extends Component {
  static propTypes = {
    createWorkCollection: PropTypes.func.isRequired,
    closeModal: PropTypes.func.isRequired,
  };

  constructor(props) {
    super(props);

    this.state = { errors: {} };
    this.handleCreateClick = this.handleCreateClick.bind(this);
  }

  render() {
    return (
      <div>
        <span style={{ float: 'right' }} onClick={this.props.closeModal}>
          <i
            className="fa fa-times"
            style={{
              cursor: 'pointer',
              margin: '8px 8px 0 0',
              fontSize: '18px',
            }}
          ></i>
        </span>
        <div style={{ width: '70%', margin: '0 auto', padding: '16px 0' }}>
          <div
            style={{
              textAlign: 'center',
              fontSize: '22px',
              margin: '24px 0 24px 0',
              color: '#000',
              fontWeight: '500',
            }}
          >
            Create List
          </div>
          <NameForm
            saveName={this.handleCreateClick}
            errors={this.state.errors.name}
            cta="Create New List"
            ctaIconClassName="fa fa-plus"
          />
        </div>
      </div>
    );
  }

  handleCreateClick(data) {
    this.props
      .createWorkCollection(data)
      .then(() => {
        this.setState({ errors: {} });
        this.props.closeModal();
      })
      .fail((err) => {
        const jsonResp = JSON.parse(err.responseText);
        if (jsonResp && jsonResp.errors) {
          this.setState({ errors: jsonResp.errors });
        }
      });
  }
}

export const MainCtaButton = styled.button`
  color: #fff;
  width: 100%;
  height: 40px;
  border-radius: 6px;
  border-style: none;
  cursor: pointer;
  font-weight: bold;
  background-color: #0954d3;

  &:hover {
    background-color: #2878ff;
  }

  &:active {
    background-color: #003796;
  }
`;

export const InactiveCtaButton = styled.button`
  color: rgb(73, 72, 72);
  width: 100%;
  height: 40px;
  border-radius: 6px;
  border-style: none;
  cursor: pointer;
  font-weight: bold;
  background-color: #eeeef0;
`;
